<template>
  <div class="twshippingprofile">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">收貨資訊</a>
      </nav>

      <!--  /////////////////////////////// -->

      <div class="card">
        <div class="title">寄送方式</div>
        <div class="card-body">
          <div class="form-group">
            <label for="name">取件人姓名</label>
            <input
              type="text"
              class="form-control"
              id="userName"
              aria-describedby="nameHelp"
              placeholder="收貨人姓名"
              v-model="from.name"
            />
          </div>
          <div class="form-group">
            <label for="phone">取件人手機</label>
            <input
              type="number"
              class="form-control"
              id="userPhone"
              placeholder="收貨人電話"
              v-model="from.phone"
            />
          </div>

          <div class="form-group">
            <label for="shippingTypeSelected">選擇取貨方式</label>
            <b-form-select
              v-model="shippingTypeSelected"
              :options="shippingTypeOptions"
            ></b-form-select>
          </div>

          <div v-show="ishomeDeliveryShow">
            <div class="form-group">
              <label for="phone">取件人地址</label>
              <input
                type="text"
                class="form-control"
                id="userAddress"
                placeholder="取件人地址"
                v-model="from.address"
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="card">
        <div class="title">付款方式</div>
        <div class="card-body">
          <div style="float: left; display: block">
            <b>選擇付款銀行:</b>
          </div>
          <b-form-select
            v-model="atmPaymentSelected"
            :options="atmPaymentOptions"
          ></b-form-select>
        </div>
      </div>
      <br />
      <div class="card">
        <div class="title">付款詳情</div>
        <div class="card-body">
          <p class="text-muted">商品總金額:{{ totalProductPrice }}元</p>
          <div v-if="freight == 0">
            <p class="text-muted">
              運費總金額:
              <b>免運費</b>
            </p>
          </div>
          <div v-else>
            <p class="text-muted">運費總金額:{{ freight }}元</p>
          </div>
          <p class="text-muted">總數量:{{ totalQuantity }}</p>
          <p class="text-muted">代買手續費:{{ processingFee }}元</p>
          <p class="text-muted">金流手續費:{{ ecpayFee }}元</p>
          <p class="text-danger">
            總付款金額:
            <b>{{ totalPrice }}元</b>
          </p>
        </div>
      </div>
      <br />
      <button class="btn btn-danger btn-lg btn-block" @click="submit()">
        結帳
      </button>
      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'twshippingprofile',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      fbEndpoint: 'https://m.me/2266831083395361',
      displayViews: null,
      isLoading: true,
      from: {
        name: '',
        phone: '',
        address: '',
      },
      isStoreShow: false,
      ishomeDeliveryShow: true,
      shippingTypeSelected: 'delivery',
      shippingTypeOptions: [
        // {
        //   value: "deliveryStore",
        //   text: "超商取貨"
        // },
        {
          value: 'delivery',
          text: '宅配',
        },
      ],
      checkMobile: isMobile ? '1' : '0',
      freight: 0,
      ecpayFee: 0,
      processingFee: 30,
      totalProductPrice: 0,
      totalQuantity: 0,
      totalPrice: 0,
      orderId: null,
      atmPaymentSelected: null,
      atmPaymentOptions: [
        {
          value: null,
          text: '請選擇付款銀行',
        },
        //   {
        //     value: "TAISHIN",
        //     text: "台新"
        //   },
        //   {
        //     value: "ESUN",
        //     text: "玉山"
        //   },
        {
          value: 'BOT',
          text: '台灣銀行',
        },
        // {
        //   value: "FUBON",
        //   text: "台北富邦"
        // },
        {
          value: 'CHINATRUST',
          text: '中國信託',
        },
        //   {
        //     value: "FIRST",
        //     text: "第一銀行"
        //   },
        //   {
        //     value: "LAND",
        //     text: "土地銀行"
        //   },
        {
          value: 'CATHAY',
          text: '國泰世華銀行',
        },
        //   {
        //     value: "TACHONG",
        //     text: "大眾銀行"
        //   }
      ],
    }
  },
  methods: {
    submit: function () {
      const vm = this
      if (vm.from.name == '') {
        vm.$toast.open({
          message: '請輸入收件人姓名',
          type: 'error',
        })
        return 0
      }
      if (vm.from.phone == '') {
        vm.$toast.open({
          message: '請輸入收件人電話',
          type: 'error',
        })
        return
      }
      if (vm.from.address == '') {
        vm.$toast.open({
          message: '請輸入收件地址',
          type: 'error',
        })
        return
      }
      if (vm.atmPaymentSelected == null) {
        vm.$toast.open({
          message: '請選擇付款銀行',
          type: 'error',
        })
        return
      }
      if (vm.displayViews != undefined) {
        vm.invokeAddOrder()
      } else {
        vm.$toast.open({
          message: '送出失敗，請聯絡客服!',
          type: 'error',
        })
      }
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (
        localStorage.userId == undefined ||
        localStorage.userImage == undefined ||
        localStorage.userName == undefined
      ) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        // vm.$router.push("alibabaorder");
        return true
      } else {
        return false
      }
    },
    checkProductsExist: function (product) {
      const vm = this
      if (product == undefined) {
        vm.$modal.show('dialog', {
          title: '🙋請聯絡客服',
          text: '請聯絡客服⚡ 系統異常!',
          buttons: [
            {
              title: '👉聯絡客服',
              handler: () => {
                window.location = vm.fbEndpoint
              },
            },
          ],
        })
      }
    },
    freightFeeByProducts: function (products) {
      let freight = 0
      let totalQuantity = 0
      let freeFreightQuantity = 0
      let productFreight = 0
      products.forEach(product => {
        totalQuantity += parseInt(product.select.quantity)
        freeFreightQuantity = product.free_freight_quantity
        productFreight = product.freight
      })
      if (totalQuantity < freeFreightQuantity) {
        freight = productFreight
      }
      return freight
    },
    ecpayFeeByTotalPrice: function (totalPrice) {
      let paymentRate = Math.ceil(Math.ceil(totalPrice) * 0.01)
      if (paymentRate <= 10) {
        paymentRate = 10
      }
      return paymentRate
    },
    totalQuantityByProducts: function (products) {
      let totalQuantity = 0

      products.forEach(product => {
        totalQuantity += parseInt(product.select.quantity)
      })
      return totalQuantity
    },
    feesByProducts: function (products) {
      const vm = this
      let totalProductPrice = 0
      let totalPrice = 0
      products.forEach(product => {
        totalProductPrice += parseInt(
          product.select.price * product.select.quantity
        )
      })
      vm.totalProductPrice = totalProductPrice
      vm.totalQuantity = vm.totalQuantityByProducts(products)
      vm.freight = vm.freightFeeByProducts(products)
      totalPrice = totalProductPrice + vm.freight + vm.processingFee
      vm.ecpayFee = vm.ecpayFeeByTotalPrice(totalPrice)
      vm.totalPrice = totalPrice + vm.ecpayFee
    },
    invokeAddOrder: function () {
      const vm = this
      ;(async function postapi() {
        vm.isLoading = true

        vm.$toast.open({
          message: '建立訂單中，請稍等片刻...',
          type: 'success',
        })

        let formData = {
          order: {
            user_id: localStorage.userId,
            user_name: localStorage.userName,
            user_image: localStorage.userImage,
            status: 0,
            price: vm.totalProductPrice,
            freight: vm.freight,
            total_price: vm.totalPrice,
            ecpay_fee: vm.ecpayFee,
            processing_fee: vm.processingFee,
            total_products_price: vm.totalProductPrice,
            total_quantity: vm.totalQuantity,
            pay: {},
            delivery: [
              {
                name: vm.from.name,
                phone: vm.from.phone,
                address: vm.from.address,
                map_info: {},
              },
            ],
            products: vm.displayViews,
          },
        }
        await axios
          .post(vm.apiUrl + 'AddTwOrder', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            if (Object.keys(response.data).length != 0) {
              vm.orderId = response.data.order_id
              vm.invokeECPayATM(response.data.order_id)

              vm.$toast.open({
                message: '建立訂單中，請稍等片刻...',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '失敗: ' + error,
              type: 'error',
            })
            vm.isLoading = false
          })
      })()
    },
    invokeECPayATM: function (orderId) {
      const vm = this
      ;(async function postapi() {
        vm.isLoading = true

        let formData = {
          orderId: orderId,
          totalAmount: vm.totalPrice,
          chooseSubPayment: vm.atmPaymentSelected,
        }
        await axios
          .post(vm.apiUrl + 'PayATMForTwProduct', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            if (Object.keys(response.data).length != 0) {
              vm.$toast.open({
                message: '建立訂單完成!',
                type: 'success',
              })
              vm.$router.push(
                'tworderdone' +
                  '?orderId=' +
                  orderId +
                  '&userId=' +
                  localStorage.userId
              )
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '失敗: ' + error,
              type: 'error',
            })
            vm.isLoading = false
          })
      })()
    },
  },
  watch: {
    'from.name': function () {
      const vm = this
      localStorage.setItem('name', vm.from.name)
    },
    'from.phone': function () {
      const vm = this
      localStorage.setItem('phone', vm.from.phone)
    },
    'from.address': function () {
      const vm = this
      localStorage.setItem('address', vm.from.address)
    },
    shippingTypeSelected: function () {
      const vm = this
      if (vm.shippingTypeSelected == 'deliveryStore') {
        vm.isStoreShow = true
        vm.ishomeDeliveryShow = false
      } else {
        vm.isStoreShow = false
        vm.ishomeDeliveryShow = true
      }
    },
  },
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = true
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.checkUnChatbotSignin()

    if (JSON.parse(localStorage.getItem('twProducts')) != undefined) {
      vm.displayViews = JSON.parse(localStorage.getItem('twProducts'))
      vm.isLoading = false
    }
    if (localStorage.getItem('address') != undefined) {
      vm.from.address = localStorage.getItem('address')
    }
    if (localStorage.getItem('name') != undefined) {
      vm.from.name = localStorage.getItem('name')
    }
    if (localStorage.getItem('phone') != undefined) {
      vm.from.phone = localStorage.getItem('phone')
    }

    vm.checkProductsExist(vm.displayViews)
    vm.feesByProducts(vm.displayViews)
  },
}
</script>
